var _defs, _circle, _g, _rect, _path, _g2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c1f81;}.cls-2{fill:#ff8f0b;}.cls-3{fill:#eaeced;}.cls-4,.cls-5,.cls-6{fill:none;}.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}.cls-5{stroke-width:4px;}.cls-6{stroke-width:5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-1",
    cx: 56.94,
    cy: 56.94,
    r: 56.94
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_155",
    "data-name": "Path 155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.53,109.29A51.59,51.59,0,0,1,4.88,57.63,51.63,51.63,0,0,1,93.06,21.11a51.68,51.68,0,0,1-16.42,84.12A51.22,51.22,0,0,1,56.53,109.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.53,8A49.65,49.65,0,0,0,21.42,92.75,49.67,49.67,0,1,0,56.53,8m0-4A53.66,53.66,0,1,1,2.88,57.63,53.66,53.66,0,0,1,56.53,4Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    className: "cls-4",
    x: 32.02,
    y: 30.05,
    width: 48.82,
    height: 54.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-1",
    d: "M41.19,64.78a17.73,17.73,0,0,1,35.45,0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-5",
    d: "M78.78,74.78a25.91,25.91,0,1,1-2-36.59,25.17,25.17,0,0,1,2.89,3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    className: "cls-1",
    x: 41.19,
    y: 47.06,
    width: 35.45,
    height: 17.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "cls-6",
    d: "M73.08,46.87a22.64,22.64,0,0,0-14.71-5.18c-5.49,0-9.38,1.89-13.62,5.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-6",
    d: "M44.77,67.94a22.62,22.62,0,0,0,14.46,5.84c5.49.29,9.47-1.46,13.85-4.74"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    className: "cls-4",
    x: 32.02,
    y: 30.05,
    width: 48.82,
    height: 54.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/Icon10.66af29923d9ab22ed89b93fb9bb267be.svg";
export { ForwardRef as ReactComponent };